// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"4fd5db9e","366":"cd2dcc4f","453":"e0eb14ff","578":"41e9be6c"}[chunkId] + ".chunk.js";
};